import { LevelsDTO } from "./LevelsDTO";

export interface ClassesDTO {
    ID: number;
    ClassID: number;
    RaceID: number;
    Name: string;
    SortOrder: number;
    MapID: number | null;
    Discipline: string;
    InternDiscipline: string;
    DisciplineID: number;
    Discipline_Info: DisciplinesDTO;
    StageType: SprintStageDTO;
    FirstStartTime: Date | string | null;
    Started: number;
    Finished: number;
    CourseID: number;
    LowerHigherBib: number;
    TimeFormat: string;
    TimeMask: string;
    FinalType: string;
    HideDNS: boolean;
    ShowTime: boolean;
    SortByRank: boolean;
    SortByStartorder: boolean;
    UseTimingCodeNumber: boolean;
    IsRelay: boolean;
    ActiveLevel: number | null;
    BibFrom: number | null;
    BibTo: number | null;
    StatusFlag: ClassStatus;
    Status: string;
    Shootings: string;
    Gender: string;
    ShortName: string;
    FreeTextDistance: string;
    StartOrder: string;
    QualifiedNext: string;
    Codex: string;
    MaxQualifiedNext: number;
    TurnOnNext: number;
    ShootTimePenalty: number;
    Laps: number;
    ExtraInfo: { [key: string]: string };    
    Level: { [key: number]: LevelsDTO };
    IsDone: boolean;
}

export enum ClassStatus {
    Entries = 0,
    ReadyForStart = 1,
    InProgress = 2,
    Finished = 4,
    Official = 5,
    HideAll = 99
}

export interface DisciplinesDTO {
    ID: number;
    Name: number;
    MultipleLevels: boolean;
    ShowRank: boolean;
    ShowTime: boolean;
    ShowPoints: boolean;
    ShowLevels: boolean;
    ShowShootings: boolean;
    ShowSprintView: boolean;
    ShowAlpineView: boolean;
    ShowResultView: boolean;
    
}
export enum SprintStageDTO {
    noSprint = 0,
    onTime30 = 30,
    onTime30bFinal = 31,
    noTime30 = 35,
    onTime16bFinal = 17,
    onTime16 = 16,
    noTime16 = 15,
    AlpineTeam16 = 117,
    Alpine32 = 132,
    Alpine16 = 116,
    Super16 = 1016,
    Super32 = 1032
    
}